import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Teleport as _Teleport, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "settings-page" }
const _hoisted_2 = { class: "tariff-header-content" }
const _hoisted_3 = { class: "portal-title" }
const _hoisted_4 = { class: "make-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "settings-content"
}
const _hoisted_7 = { class: "settings-card hourly-card" }
const _hoisted_8 = { class: "card-left" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title-box" }
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = { class: "card-subtitle" }
const _hoisted_13 = { class: "form-grid" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "help-text" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "help-text" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "help-text" }
const _hoisted_20 = { class: "card-right preview-box" }
const _hoisted_21 = { class: "preview-title" }
const _hoisted_22 = { class: "preview-content" }
const _hoisted_23 = { class: "preview-formula" }
const _hoisted_24 = { class: "preview-math" }
const _hoisted_25 = { class: "preview-savings" }
const _hoisted_26 = { class: "settings-card" }
const _hoisted_27 = { class: "card-header" }
const _hoisted_28 = { class: "card-title-box" }
const _hoisted_29 = { class: "card-title" }
const _hoisted_30 = { class: "card-subtitle" }
const _hoisted_31 = { class: "form-row-2" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "tiers-grid" }
const _hoisted_35 = { class: "tier-card" }
const _hoisted_36 = { class: "tier-header" }
const _hoisted_37 = { class: "tier-name" }
const _hoisted_38 = { class: "tier-input-wrapper" }
const _hoisted_39 = { class: "tier-card" }
const _hoisted_40 = { class: "tier-header" }
const _hoisted_41 = { class: "tier-name" }
const _hoisted_42 = { class: "tier-input-wrapper" }
const _hoisted_43 = { class: "tier-card" }
const _hoisted_44 = { class: "tier-header" }
const _hoisted_45 = { class: "tier-name" }
const _hoisted_46 = { class: "tier-input-wrapper" }
const _hoisted_47 = { class: "tier-card" }
const _hoisted_48 = { class: "tier-header" }
const _hoisted_49 = { class: "tier-name" }
const _hoisted_50 = { class: "tier-input-wrapper" }
const _hoisted_51 = { class: "settings-card security-card" }
const _hoisted_52 = { class: "card-header" }
const _hoisted_53 = { class: "card-title-box" }
const _hoisted_54 = { class: "card-title" }
const _hoisted_55 = { class: "card-subtitle" }
const _hoisted_56 = { class: "form-group narrow-group" }
const _hoisted_57 = { class: "settings-footer" }
const _hoisted_58 = ["disabled"]

import { ref, reactive, computed, onMounted, watch, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import {
  Clock,
  Monitor,
  Calendar,
  Edit,
  Lock,
  DocumentChecked,
} from '@element-plus/icons-vue'
import CommonError from '@/components/CommonError.vue'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'
import { useGolfHeaderStore } from '@/store/golf-header'
import { useGolfI18n } from '@/composables/useGolfI18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const golfStore = useGolfVehiclesStore()
const headerStore = useGolfHeaderStore()
const { t: golfT } = useGolfI18n()

const route = useRoute()
const router = useRouter()
const activeMakeId = ref<string | null>((route.query.make as string) || null)
const isMounted = ref(false)

watch(activeMakeId, newId => {
  if (newId) {
    router.replace({ query: { ...route.query, make: newId } })
  }
})
const isSaving = ref(false)

const formState = reactive({
  fixed_30_min_rate: 12.0,
  base_hourly_rate: 20.0,
  subsequent_hour_discount: 10,
  workday_rate: 100.0,
  weekend_rate: 120.0,
  tier1_discount_pct: 10,
  tier2_discount_pct: 15,
  tier3_discount_pct: 20,
  tier4_discount_pct: 30,
  deposit: 100.0,
})

const makes = computed(() => {
  return Array.isArray(golfStore.profiles) ? golfStore.profiles : []
})

const activeMake = computed(() => {
  if (!activeMakeId.value) return null
  return (
    makes.value.find(
      (m: Record<string, unknown>) => m.id === activeMakeId.value
    ) || null
  )
})

// Math logic for Live Preview
const twoHourBase = computed(() => (formState.base_hourly_rate || 0) * 2)
const twoHourDiscountAmount = computed(() => {
  const hrRate = formState.base_hourly_rate || 0
  const discountPct = formState.subsequent_hour_discount || 0
  return hrRate * (discountPct / 100)
})
const twoHourPreview = computed(() => {
  const val = twoHourBase.value - twoHourDiscountAmount.value
  return val.toFixed(2)
})
const twoHourSavings = computed(() => {
  return twoHourDiscountAmount.value.toFixed(2)
})

const populateForm = () => {
  if (!activeMake.value) return
  const tariff = (activeMake.value as Record<string, any>).tariff || {}

  formState.fixed_30_min_rate = tariff.fixed_30_min_rate || 12.0
  formState.base_hourly_rate = tariff.base_hourly_rate || 20.0
  formState.subsequent_hour_discount = tariff.subsequent_hour_discount || 10

  formState.workday_rate = tariff.workday_rate || 100.0
  formState.weekend_rate = tariff.weekend_rate || 120.0

  formState.tier1_discount_pct = tariff.tier1_discount_pct || 10
  formState.tier2_discount_pct = tariff.tier2_discount_pct || 15
  formState.tier3_discount_pct = tariff.tier3_discount_pct || 20
  formState.tier4_discount_pct = tariff.tier4_discount_pct || 30

  formState.deposit = tariff.deposit || 100.0
}

watch(
  activeMake,
  () => {
    populateForm()
  },
  { immediate: true }
)

const selectMake = (id: string) => {
  activeMakeId.value = id
  populateForm()
}

const discardChanges = () => {
  populateForm()
}

const saveSettings = async () => {
  if (!activeMake.value) return

  isSaving.value = true
  try {
    const profileName =
      (activeMake.value as Record<string, any>).name || 'Default'
    const tariffPayload = {
      name: `${profileName} Tariff`,
      pricing_type: 'hybrid',
      fixed_30_min_rate: formState.fixed_30_min_rate,
      base_hourly_rate: formState.base_hourly_rate,
      subsequent_hour_discount: formState.subsequent_hour_discount,
      workday_rate: formState.workday_rate,
      weekend_rate: formState.weekend_rate,
      tier1_discount_pct: formState.tier1_discount_pct,
      tier2_discount_pct: formState.tier2_discount_pct,
      tier3_discount_pct: formState.tier3_discount_pct,
      tier4_discount_pct: formState.tier4_discount_pct,
      deposit: formState.deposit,
      is_active: true,
    }

    const currentTariff = (activeMake.value as Record<string, any>).tariff
    if (currentTariff?.id) {
      await golfStore.updateTariff(currentTariff.id, tariffPayload as any)
    } else {
      const newTariff = await golfStore.createTariff(tariffPayload as any)
      if (newTariff) {
        // Link the new tariff to the profile
        const profileId = (activeMake.value as Record<string, any>).id
        await golfStore.updateProfile(profileId, {
          tariff_id: newTariff.id,
        } as any)
      }
    }

    // Refresh profiles to get updated tariff data
    await golfStore.fetchProfiles()
    ElMessage.success(golfT('golf.tariffs.tariff_saved_success'))
  } catch (error) {
    console.error(error)
    ElMessage.error(golfT('golf.tariffs.tariff_save_failed'))
  } finally {
    isSaving.value = false
  }
}

const onRetryPress = () => {
  golfStore.fetchProfiles()
}

onMounted(async () => {
  isMounted.value = true
  headerStore.setCustomHeader(true)
  headerStore.setHeaderInfo('golf.tariffs.title', false)
  await golfStore.fetchProfiles()
  if (
    activeMakeId.value &&
    makes.value.some((m: any) => m.id === activeMakeId.value)
  ) {
    selectMake(activeMakeId.value)
  } else if (makes.value.length > 0) {
    selectMake(makes.value[0].id)
  }
})

onUnmounted(() => {
  headerStore.setCustomHeader(false)
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(golfStore).error)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: _unref(golfStore).error,
          onRetryPress: onRetryPress
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (isMounted.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "#golf-header-portal"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('golf.tariffs.title')), 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(makes.value, (make) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: make.id,
                    class: _normalizeClass(["make-tab", { active: activeMakeId.value === make.id }]),
                    onClick: ($event: any) => (selectMake(make.id))
                  }, _toDisplayString(make.name), 11, _hoisted_5))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeMake.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-icon" }, [
                    _createElementVNode("img", {
                      src: "/icons_golf_module/Tarriff & Settings Hourly price.svg",
                      alt: "Hourly",
                      style: {"width":"24px","height":"24px"}
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('golf.tariffs.hourly_price_calibration')), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('golf.tariffs.short_term_economics_desc')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.fixed_30min_rate')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formState.fixed_30_min_rate) = $event))
                    }, null, 512), [
                      [_vModelText, formState.fixed_30_min_rate]
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('golf.tariffs.fixed_30min_help')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.base_hourly_rate')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState.base_hourly_rate) = $event))
                    }, null, 512), [
                      [_vModelText, formState.base_hourly_rate]
                    ]),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('golf.tariffs.applies_strictly_first_hour')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.subsequent_hour_discount')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formState.subsequent_hour_discount) = $event))
                    }, null, 512), [
                      [_vModelText, formState.subsequent_hour_discount]
                    ]),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('golf.tariffs.subsequent_hour_discount_help')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('golf.trips.live_preview_box')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                      src: "/icons_golf_module/Tarriff & Settings Formula Preview.svg",
                      alt: "Preview",
                      style: {"width":"18px","height":"18px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.tariffs.formula_preview_for', {
                  model: activeMake.value.name,
                })), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.tariffs.hours_formula_preview', {
                  hours: 2,
                  formula: `₼${formState.base_hourly_rate ||
                    '0.00'} + (₼${formState.base_hourly_rate ||
                    '0.00'} - ${formState.subsequent_hour_discount || '0'}%)`,
                })) + " ", 1),
                    _createElementVNode("span", null, "₼" + _toDisplayString(twoHourPreview.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('golf.tariffs.your_savings', {
                  amount: `₼${twoHourSavings.value}`,
                })), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-icon" }, [
                  _createElementVNode("img", {
                    src: "/icons_golf_module/Tarriff & Settings Daily price.svg",
                    alt: "Daily",
                    style: {"width":"24px","height":"24px"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.$t('golf.tariffs.daily_price_calibration')), 1),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('golf.tariffs.daily_price_calibration_desc')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.base_workday_rate')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formState.workday_rate) = $event))
                  }, null, 512), [
                    [_vModelText, formState.workday_rate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.base_weekend_rate')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formState.weekend_rate) = $event))
                  }, null, 512), [
                    [_vModelText, formState.weekend_rate]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('golf.tariffs.tier_1')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Edit))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formState.tier1_discount_pct) = $event))
                    }, null, 512), [
                      [_vModelText, formState.tier1_discount_pct]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "pct-symbol" }, "%", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('golf.tariffs.tier_2')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Edit))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formState.tier2_discount_pct) = $event))
                    }, null, 512), [
                      [_vModelText, formState.tier2_discount_pct]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "pct-symbol" }, "%", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('golf.tariffs.tier_3')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Edit))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formState.tier3_discount_pct) = $event))
                    }, null, 512), [
                      [_vModelText, formState.tier3_discount_pct]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "pct-symbol" }, "%", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('golf.tariffs.tier_4')), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Edit))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formState.tier4_discount_pct) = $event))
                    }, null, 512), [
                      [_vModelText, formState.tier4_discount_pct]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "pct-symbol" }, "%", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-icon red-icon" }, [
                  _createElementVNode("img", {
                    src: "/icons_golf_module/Tarriff & Settings Eligibility Guards.svg",
                    alt: "Guards",
                    style: {"width":"24px","height":"24px"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("h2", _hoisted_54, _toDisplayString(_ctx.$t('golf.tariffs.eligibility_guards')), 1),
                  _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t('golf.tariffs.eligibility_guards_desc')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.tariffs.fixed_security_deposit')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.01",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formState.deposit) = $event))
                }, null, 512), [
                  [_vModelText, formState.deposit]
                ])
              ])
            ])
          ])), [
            [_directive_loading, _unref(golfStore).isLoading]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("span", {
          class: "discard-link",
          onClick: discardChanges
        }, _toDisplayString(_ctx.$t('golf.common.discard_changes')), 1),
        _createElementVNode("button", {
          class: "save-btn",
          disabled: isSaving.value,
          onClick: saveSettings
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("img", {
            src: "/icons_golf_module/Tariff_save button.svg",
            alt: "Save",
            style: {"width":"18px","height":"18px"}
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.common.save_changes')), 1)
        ], 8, _hoisted_58)
      ])
    ])
  ], 64))
}
}

})